export default [
  {
    title: 'Ongi etorri',
    element: 'body',
    text: 'Ongi etorri Idoniara, zure irudiak trukatzeko plataformara. Tour honetan erabiltzen ikasten lagunduko dizugu.',
    placement: {
      relativeTo: 'viewport',
      position: 'bottom right'
    }
  },
  {
    title: 'Nire gunea',
    element: '.file-container',
    text: '"Nire gunea" esparruan Idonian dituzun karpeta, dokumentu eta azterketa guztiak ikusi ahal izango dituzu. Arrastatu hona Idonian gorde nahi dituzun karpetak edo fitxategiak.',
    placement: {
      relativeTo: 'viewport',
      position: 'center center'
    }
  },
  {
    title: '"Berria" botoia',
    element: 'button.new',
    text: 'Erabili menu hau edukien karpeta bat sortzeko, fitxategi bat edo zure gailuaren karpetak igotzeko. DICOM azterketa oso bat ere igo dezakezu ikusteko.',
    placement: {
      relativeTo: 'element',
      position: 'left top'
    }
  },
  {
    title: 'Partekatutako fitxategiak',
    element: 'a[data-name="shared"]',
    text: '"Nirekin partekatuta" atalean, beste erabiltzaile batzuek partekatutako fitxategiak eta karpetak ikusi ahal izango dituzu.',
    placement: {
      relativeTo: 'element',
      position: 'right bottom'
    }
  }
]



// WEBPACK FOOTER //
// ./src/components/common/tour/tours/desktop/eu-ES/regular.js